import React, { Fragment, useCallback } from 'react';
import classnames from 'classnames';
import { List } from 'react-admin';
import { Route, useHistory } from 'react-router-dom';
import { Drawer, useMediaQuery, makeStyles } from '@material-ui/core';
import BulkAcceptButton from './BulkAcceptButton';
// import BulkRejectButton from './BulkRejectButton';

import SupplierListMobile from './SupplierListMobile';
import SupplierListDesktop from './SupplierListDesktop';
import SupplierFilter from './SupplierFilter';
import SupplierEdit from './SupplierEdit';

const SuppliersBulkActionButtons = props => (
    <Fragment>
        <BulkAcceptButton {...props} />
        {/* <BulkRejectButton {...props} /> */}
    </Fragment>
);

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    list: {
        flexGrow: 1,
        transition: theme.transitions.create(['all'], {
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: 0,
    },
    listWithDrawer: {
        // marginRight: 400,
    },
    drawerPaper: {
        zIndex: 100,
    },
}));

const SupplierList = ({ permissions, ...props }) => {
    const classes = useStyles();
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const history = useHistory();

    const handleClose = useCallback(() => {
        history.push('/suppliers');
    }, [history]);

    return (
        <div className={classes.root}>
            <Route path="/suppliers/:id">
                {({ match }) => {
                    const isMatch = !!(
                        match &&
                        match.params &&
                        match.params.id !== 'create'
                    );

                    if (permissions) return (
                        <Fragment>

                            <List
                                {...props}
                                className={classnames(classes.list, {
                                    [classes.listWithDrawer]: isMatch,
                                })}
                                bulkActionButtons={<SuppliersBulkActionButtons />}
                                filters={<SupplierFilter />}
                                filter={
                                  permissions.role.type === 'supplier' ? { id: permissions.supplier.id } : {}
                                }
                                perPage={25}
                                sort={{ field: 'createdAt', order: 'DESC' }}
                            >
                                {isXSmall ? (
                                    <SupplierListMobile />
                                ) : (
                                    <SupplierListDesktop />
                                )}
                            </List>
                            <Drawer
                                variant="persistent"
                                open={isMatch}
                                anchor="right"
                                onClose={handleClose}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                            >
                                {/* To avoid any errors if the route does not match, we don't render at all the component in this case */}
                                {isMatch ? (
                                    <SupplierEdit
                                        id={match.params.id}
                                        onCancel={handleClose}
                                        {...props}
                                        permissions={permissions}
                                    />
                                ) : null}
                            </Drawer>
                        </Fragment>
                    );
                }}
            </Route>
        </div>
    );
};

export default SupplierList;
